<template>
	<div>
		<cover :pageData="pageData"></cover>
		<div class="page">
			<div class="title">
				<div class="cn_title">{{ pageData.firstTitle }}{{ pageData.secondTitle }}</div>
				<div class="en_title">NEWS INFORMATION</div>
			</div>
			<!-- 选项 -->
			<div class="options">
				<div class="option" v-for="(option, index) in optionList" :key="index"
					:class="tabIndex == index ? 'blue_bg' : ''" @click="chooseOption(index)">{{ option.name }}</div>
			</div>
			<!-- 新闻 -->
			<div class="news">
				<div class="new" v-for="(item) in newsList" :key="item.id" @click="toNews(item.id)">
					<div class="news_left">
						<img :src="img_api + item.image" alt="">
					</div>
					<div class="news_right">
						<div class="news_title">{{ item.name }}</div>
						<div class="news_des">{{ item.brief }}</div>
						<div class="news_time">{{ item.time }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pag">
			<el-pagination :current-page="currentPage" :page-size="pageSize" :total="total"
				@current-change="handleCurrentChange" background layout="prev, pager, next">
			</el-pagination>
		</div>

	</div>
</template>

<script>
import cover from '../components/cover.vue'
import { getNews } from '../server/https';
export default {
	name: '',
	components: {
		cover
	},
	data() {
		return {
			currentPage: 1, // 当前页码默认值为1
			pageSize: 4, // 每页显示条数默认值为10
			total: 0, // 数据总数
			tabIndex: 0,
			pageData: {
				firstTitle: '',
				secondTitle: '',
				bannerImg: '',
				des: ''
			},
			optionList: [
				{ name: "全部", isActive: true },
				{ name: "企业新闻", isActive: false },
				{ name: "行业资讯", isActive: false }
			],
			newsList: [],
            img_api: 'https://www.gdyuanwo.com/gdyuanwo/',
			api: 'http://192.168.31.41:7070/gpa/gpwx'
		}
	},
	mounted() {
		this.getNewsList();
		this.tabIndex = this.$route.query.tabIndex;
		var setI = setInterval(() => {
			if (this.$store.state.headList != '') {
				var headList = this.$store.state.headList
				headList.map(item => {
					if (item.sort == 2) {
						let Name = item.name;
						this.pageData.firstTitle = Name.slice(0, -2);
						this.pageData.secondTitle = Name.substr(-2);
						this.pageData.bannerImg = item.image;
						this.pageData.des = item.details;
					}
				})
				clearInterval(setI)
			}
		}, 200)
	},
	methods: {
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage;
			if(this.tabIndex==0){
				this.getNewsList()
			}
			else{
				this.getTypeNews(this.tabIndex)
			}
		},
		//获取全部新闻
		getNewsList() {
			getNews({ pageNo: this.currentPage, pageSize: this.pageSize }).then(res => {
				res.data.body.page.list.sort((a, b) => a.sort - b.sort);
				this.newsList = res.data.body.page.list;
				this.total = res.data.body.page.count;
			})
		},
		//获取类型新闻
		getTypeNews(index){
			getNews({ pageNo: this.currentPage, pageSize: this.pageSize, type: index }).then(res => {
					res.data.body.page.list.sort((a, b) => a.sort - b.sort);
					this.newsList = res.data.body.page.list;
					this.total = res.data.body.page.count;
				})
		},
		
		chooseOption(index) {
			this.tabIndex = index;
			this.currentPage=1;
			if (index != 0) {
				this.getTypeNews(index)
			}
			else{
				this.getNewsList();
			}

		},

		toNews(e) {
			this.$router.push({
				name: "NewsDetail",
				query: {
					newsId: e,
				}
			});
		},
	},
};
</script>

<style scoped>

.page {
	/* height: 866px; */
	position: relative;
	background: #FFFFFF;
}

.news {
	width: 1000px;
	margin: auto;
	margin-bottom: 40px;
	margin-top: 20px;
}

.news_right {
	width: 600px;
	margin-left: 20px;
}

/* 大标题 */
.title {
	display: flex;
	justify-content: center;
}

.cn_title {
	font-size: 48px;
	font-weight: bold;
	color: #13489D;
	margin-top: 56px;
	z-index: 2;
}

.en_title {
	position: absolute;
	font-size: 54px;
	font-weight: bold;
	color: #C8D4E1;
	margin-top: 56px;
}

/* 选项 */
.options {
	display: flex;
	justify-content: center;
	margin-top: 40px;
}

.option {
	width: 64px;
	height: 32px;
	line-height: 32px;
	text-align: center;
	padding: 4px;
	border-radius: 20px;
	margin: 10px;
	color: #666666;
}

.blue_bg {
	background-color: #13489D;
	color: #FFFFFF;
}

/* 新闻 */
.new {
	display: flex;
	padding: 20px;
	border-bottom: 1px solid #999999;
	cursor: pointer;
}

.news_left {
	width: 354px;
	height: 204px;
}

.news_left img {
	width: 100%;
	height: 100%;
}

.news_title {
	font-size: 16px;
	font-weight: 500;
	color: #333333;
}

.news_des {
	margin-top: 16px;
	font-size: 14px;
	font-weight: 400;
	color: #999999;
}

.news_time {
	margin-top: 16px;
	font-size: 14px;
	font-weight: 400;
	color: #999999;
}

.pag {
	float: right;
	margin-bottom: 40px;
	margin-right: 200px;
}

.el-pagination.is-background .el-pager li:not(.disabled).active /deep/ {
	background-color: #13489D;

}
</style>
